import {
  REQUEST_FAILED,
  REQUEST_GET_USER_APPS,
  REQUEST_INVALIDATE_APP,
  REFRESH_USER_APPS,
  REQUEST_CREATE_NEW_APP,
  REQUEST_GET_APP_INFO,
  REQUEST_UPDATE_APP_INFO,
  REFRESH_APP_INFO,
  REQUEST_GET_APP_TEMPLATE,
  REQUEST_UPDATE_APP_TEMPLATE,
  REFRESH_APP_TEMPLATE,
  REFRESH_CUSTOM_APPS,
  SET_SELECTED_APP,
  SET_PROVIDER_APPID,
  CLEAR_APP_TEMPLATE,
  REQUEST_DELETE_PROGRAM,
  REQUEST_UPDATE_PROGRAM,
  providerAppId,
  GET_APP_FAVORITES,
  ADD_APP_FAVORITE,
  DELETE_APP_FAVORITE,
} from "../actions/apps";

import { LOG_OUT, REQUEST_SIGNIN } from "../actions/user";

const defaultState = {
  isLoading: false,
  appInfos: [],
  customApps: [],
  appTemplates: [],
  selectedAppId: -1,
  providerAppId: null,
  appFavorite: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    case REQUEST_GET_USER_APPS:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_INVALIDATE_APP:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_USER_APPS:
      return Object.assign({}, state, {
        isLoading: false,
        appInfos: action.apps,
      });
    case REFRESH_CUSTOM_APPS:
      return Object.assign({}, state, {
        isLoading: false,
        customApps: action.customApps,
      });
    case REQUEST_CREATE_NEW_APP:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_GET_APP_INFO:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_UPDATE_APP_INFO:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_APP_INFO:
      return Object.assign({}, state, {
        isLoading: false,
        appInfos: Object.assign({}, state.appInfos, {
          [action.appId]: action.appInfo,
        }),
      });
    case REQUEST_GET_APP_TEMPLATE:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case CLEAR_APP_TEMPLATE:
      return Object.assign({}, state, {
        appTemplates: [],
      });
    case REQUEST_UPDATE_APP_TEMPLATE:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_APP_TEMPLATE:
      return Object.assign({}, state, {
        isLoading: false,
        appTemplates: Object.assign({}, state.appTemplates, {
          [action.appId]: action.appTemplate,
        }),
      });

    case SET_PROVIDER_APPID:
      return Object.assign({}, state, {
        providerAppId: action.appId,
      });
    case SET_SELECTED_APP:
      return Object.assign({}, state, {
        selectedAppId: action.appId,
      });
    case REQUEST_UPDATE_PROGRAM: {
      let updatedAppTemplates = state.appTemplates;
      let selectedAppTemplate = updatedAppTemplates[state.providerAppId];

      let found = false;
      let updatedPrograms = selectedAppTemplate.programs.map((p) => {
        if (p.programId === action.program.programId) {
          found = true;
          return action.program;
        } else {
          return p;
        }
      });

      if (!found) {
        updatedPrograms.push(action.program);
      }

      selectedAppTemplate.programs = updatedPrograms;
      updatedAppTemplates[state.providerAppId] = selectedAppTemplate;

      return Object.assign({}, state, {
        appTemplates: updatedAppTemplates,
      });
    }
    case REQUEST_DELETE_PROGRAM: {
      let updatedAppTemplates = state.appTemplates;
      let selectedAppTemplate = updatedAppTemplates[state.providerAppId];

      let updatedPrograms = selectedAppTemplate.programs.filter((p) => {
        return p.programId !== action.programId;
      });

      selectedAppTemplate.programs = updatedPrograms;
      updatedAppTemplates[state.providerAppId] = selectedAppTemplate;

      return Object.assign({}, state, {
        appTemplates: updatedAppTemplates,
      });
    }

    case DELETE_APP_FAVORITE:
      let removedAppFavorite = state.appFavorite;
      if (removedAppFavorite && removedAppFavorite.instructions) {
        removedAppFavorite.instructions =
          removedAppFavorite.instructions.filter((id) => {
            return id !== action.instructionId;
          });
      } else {
        removedAppFavorite.instructions = [];
        removedAppFavorite.appId = action.appId;
      }
      return Object.assign({}, state, {
        isLoading: false,
        appFavorite: removedAppFavorite,
      });
    case ADD_APP_FAVORITE:
      let updateAppFavorite = state.appFavorite;
      if (updateAppFavorite && updateAppFavorite.instructions) {
        updateAppFavorite.instructions.push(action.instructionId);
      } else {
        updateAppFavorite.instructions = [action.instructionId];
      }
      return Object.assign({}, state, {
        isLoading: false,
        appFavorite: updateAppFavorite,
      });
    case GET_APP_FAVORITES:
      return Object.assign({}, state, {
        isLoading: false,
        appFavorite: action.appFavorite,
      });
    case LOG_OUT:
      return {
        isLoading: false,
        appInfos: [],
        customApps: [],
        appTemplates: [],
        selectedAppId: -1,
        providerAppId: null,
        appFavorite: [],
      };
    case REQUEST_SIGNIN:
      return {
        isLoading: false,
        appInfos: [],
        customApps: [],
        appTemplates: [],
        selectedAppId: -1,
        providerAppId: null,
        appFavorite: [],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/apps.js